export default "__VITE_ASSET__DZBlpzWe__"